import {
  FETCH_LOGS_REQUEST,
  FETCH_LOGS_SUCCESS,
  FETCH_LOGS_DATE_CHART_REQUEST,
  FETCH_LOGS_DATE_CHART_SUCCESS,
  FETCH_LOGS_TYPE_CHART_REQUEST,
  FETCH_LOGS_TYPE_CHART_SUCCESS
} from '../types/logTypes';

export const fetchLogs = () => async (dispatch) => {
  dispatch({ type: FETCH_LOGS_REQUEST });
  dispatch({
    type: FETCH_LOGS_SUCCESS,
    payload: { success: true, data: { items: [], objects: { total: 0 } } }
  });
};

export const fetchLogsDateChart = () => async (dispatch) => {
  dispatch({ type: FETCH_LOGS_DATE_CHART_REQUEST });
  dispatch({
    type: FETCH_LOGS_DATE_CHART_SUCCESS,
    payload: { success: true, data: [] }
  });
};

export const fetchLogsTypeChart = () => async (dispatch) => {
  dispatch({ type: FETCH_LOGS_TYPE_CHART_REQUEST });
  dispatch({
    type: FETCH_LOGS_TYPE_CHART_SUCCESS,
    payload: { success: true, data: [] }
  });
};
